import type { QueryClient } from "@tanstack/react-query";

import type { AuthSessionSnapshot, SessionSnapshot } from "@/lib/auth-server-fns";
import { setClientAttribution } from "@/lib/marketing-context";
import {
  VIEWER_CONTEXT_QUERY_KEY,
  invalidateViewerContext,
  patchViewerContextQueryData,
} from "@/lib/viewer-context";

export function snapshotToQueryData(session: SessionSnapshot): AuthSessionSnapshot | null {
  return session.user ? { user: session.user } : null;
}

export function invalidateSession(queryClient: QueryClient) {
  return invalidateViewerContext(queryClient);
}

export function clearSession(queryClient: QueryClient) {
  void queryClient.cancelQueries({ queryKey: VIEWER_CONTEXT_QUERY_KEY });
  setClientAttribution({});
  patchViewerContextQueryData(queryClient, { user: null });
}
